module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10198.883e0c75.jpg";